module.exports = __webpack_public_path__ + "static/media/garbage.23fb6961.svg";